module.exports = __webpack_public_path__ + "static/media/90671.14b41322.jpg";